//定义相关组件
const rate = () => import('@/views/example/Rate')
const formValidate = () => import('@/views/example/FormValidate')
const test1 = () => import('@/views/example/Test1')
const test2 = () => import('@/views/example/Test2')
const test3 = () => import('@/views/example/Test3')
const test4 = () => import('@/views/example/Test4')
const businessCard = () => import('@/views/businessCard/BusinessCard')
const InformationList = () => import('@/views/businessCard/InformationList')
const editBusinessCard = () => import('@/views/businessCard/EditBusinessCard')
const myStyle = () => import('@/views/businessCard/MyStyle')
const transition = () => import('@/views/businessCard/Transition')
const posterList = () => import('@/views/poster/PosterList')
const posterPreview = () => import('@/views/poster/PosterPreview')
const birthdayList = () => import('@/views/birthday/list')
const birthdayDetails = () => import('@/views/birthday/cardDetails')
const cardShare = () => import('@/views/birthday/cardShare')
const newsCenterList = () => import('@/views/newsCenter/newsCenterList')
const newsCenterListInfo = () => import('@/views/newsCenter/newsCenterListInfo')
const teamInfo = () => import('@/views/teamInfo/teamInfo')

const settings = () => import('@/views/system/settings')
const results = () => import('@/views/system/results')
const mine = () => import('@/views/system/mine')
const income = () => import('@/views/system/income')

const increase = () => import('@/views/increase/increase')
const increasewx = () => import('@/views/increase/increaseWX')
const increaseState = () => import('@/views/increase/increaseState')
const disclosure = () => import('@/views/system/disclosure')
const pensionCalculator = () => import('@/views/pensionCalculator/pensionCalculator')
const announcement = () => import('@/views/system/announcement')
const information = () => import('@/views/system/information')
export default [
  {
    path: '/pensionCalculator',
    name: 'pensionCalculator',
    component: pensionCalculator,
    meta: {
      title: '养老金计算器',
      index: 1,
      auth: true
    }
  },

  {
    path: '/teamInfo',
    name: 'teamInfo',
    component: teamInfo,
    meta: {
      title: '团队信息查询',
      index: 3
    }
  },

  {
    path: '/newsCenterList',
    name: 'newsCenterList',
    component: newsCenterList,
    meta: {
      title: '消息中心',
      index: 1
    }
  },
  {
    path: '/newsCenterListInfo',
    name: 'newsCenterListInfo',
    component: newsCenterListInfo,
    meta: {
      title: '消息中心',
      index: 1
    }
  },
  {
    path: '/rate',
    name: 'rate',
    component: rate,
    meta: {
      title: '评分示例',
      index: 1
    }
  },
  {
    path: '/formValidate',
    name: 'formValidate',
    component: formValidate,
    meta: {
      title: '表单校验示例',
      auth: true,
      index: 1
    }
  },
  {
    path: '/test1',
    name: 'test1',
    component: test1,
    meta: {
      title: '测试一',
      index: 1
    }
  },
  {
    path: '/test2',
    name: 'test2',
    component: test2,
    meta: {
      title: '测试二',
      index: 1
    }
  },
  {
    path: '/test3',
    name: 'test3',
    component: test3,
    meta: {
      title: '测试三',
      index: 1
    }
  },
  {
    path: '/test4',
    name: 'test4',
    component: test4,
    meta: {
      title: '测试四',
      index: 1
    }
  },
  {
    path: '/businessCard',
    name: 'businessCard',
    component: businessCard,
    meta: {
      title: '电子名片',
      index: 1,
      auth: true
    }
  },
  {
    path: '/InformationList',
    name: 'InformationList',
    component: InformationList,
    meta: {
      title: '咨询列表',
      index: 1
    }
  },
  {
    path: '/editBusinessCard',
    name: 'editBusinessCard',
    component: editBusinessCard,
    meta: {
      title: '编辑名片',
      index: 1,
      auth: true
    }
  },

  {
    path: '/myStyle',
    name: 'myStyle',
    component: myStyle,
    meta: {
      title: '我的风采',
      index: 1,
      auth: true
    }
  },
  {
    path: '/transition',
    name: 'transition',
    component: transition,
    meta: {
      title: '过渡页',
      index: 1,
      auth: true
    }
  },
  {
    path: '/posterList',
    name: 'posterList',
    component: posterList,
    meta: {
      title: '海报制作',
      index: 1,
      auth: true
    }
  },
  {
    path: '/posterPreview',
    name: 'posterPreview',
    component: posterPreview,
    meta: {
      title: '海报预览',
      index: 1,
      auth: true
    }
  },
  {
    path: '/birthdayCard/list',
    name: 'birthdayList',
    component: birthdayList,
    meta: {
      title: '生日贺卡',
      index: 1,
      auth: true
    }
  },
  {
    path: '/birthdayCard/details',
    name: 'birthdayDetails',
    component: birthdayDetails,
    meta: {
      title: '生日贺卡',
      index: 1,
      auth: true
    }
  },
  {
    path: '/birthdayCard/share',
    name: 'cardShare',
    component: cardShare,
    meta: {
      title: '分享生日贺卡',
      index: 1,
      auth: false
    }
  },
  {
    path: '/settings',
    name: 'settings',
    component: settings,
    meta: {
      title: '系统设置',
      index: 3,
      auth: true
    }
  },
  {
    path: '/results',
    name: 'results',
    component: results,
    meta: {
      title: '业绩查询',
      // index: 3,
      auth: true
    }
  },
  {
    path: '/income',
    name: 'income',
    component: income,
    meta: {
      title: '收入查询',
      // index: 3,
      auth: true
    }
  },
  {
    path: '/mine',
    name: 'mine',
    component: mine,
    meta: {
      title: '我的',
      index: 3,
      auth: true
    }
  },
  {
    path: '/increase',
    name: 'increase',
    component: increase,
    meta: {
      title: '在线招募',
      index: 1,
      auth: true
    }
  },
  {
    path: '/increaseWX',
    name: 'increasewx',
    component: increasewx,
    meta: {
      title: '在线招募',
      auth: false
    }
  },
  {
    path: '/increaseState',
    name: 'increaseState',
    component: increaseState,
    meta: {
      title: '招募状态',
      index: 1,
      auth: true
    }
  },
  {
    path: '/disclosure',
    name: 'disclosure',
    component: disclosure,
    meta: {
      title: '信息披露',
      index: 3,
      auth: true
    }
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: announcement,
    meta: {
      title: '公告管理',
      index: 3,
      auth: true
    }
  },
  {
    path: '/information',
    name: 'information',
    component: information,
    meta: {
      title: '新增咨讯',
      index: 3,
      auth: true
    }
  }
]
